import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const { t } = useTranslation('home');

  return (
    <section id="guides" className="py-16 md:py-20 bg-background-50">
      <div className="container-main">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block text-xs font-medium text-accent-600 uppercase tracking-wider mb-2">
            {t('common.independent')}
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
            {t('articles.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t('articles.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <a
              key={article.id}
              href={`/${article.slug}`}
              className="group block rounded-lg bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300 hover:-translate-y-1"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={t(article.i18nTitle)}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-secondary-100 text-secondary-700">
                    {article.tag}
                  </span>
                  <span className="text-xs text-foreground-400">
                    {article.readTime} {t('common.read_time')}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {t(article.i18nTitle)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">
                  {t(article.i18nDesc)}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  {t('articles.read_more')}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}